"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 1.3.2021
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converter for member credits.
 *
 * @author Radek Beran
 */


var MemberCreditsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(MemberCreditsConverter, _DataObjectConverter_);

  function MemberCreditsConverter() {
    _classCallCheck(this, MemberCreditsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(MemberCreditsConverter).apply(this, arguments));
  }

  return MemberCreditsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.MemberCreditsConverter = MemberCreditsConverter;